import React, { useState,useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import { parseISO, format,parse } from 'date-fns';
import MoodIcon from "@mui/icons-material/Mood"; // For "Great" rating
import MoodBadIcon from "@mui/icons-material/MoodBad"; // For "Terrible" rating
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied"; // For "Bad" rating
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied"; // For "Ok" rating
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied"; // For "Good" rating
import BedtimeIcon from "@mui/icons-material/Bedtime"; // Slept icon
import WbSunnyIcon from "@mui/icons-material/WbSunny"; // Wake Up icon
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import PWAHeader from "../common/PWAHeader";
import DatePickerRow from "../common/DatePickerRow";
import PrimaryButton from "../common/PrimaryButton";
import './Fsn25LogSleep.css';
import {  Delete} from '@mui/icons-material';
import { Moon } from 'lucide-react';
import {  fetchSleepData, saveSleepLogData,deleteUserSleepLogEntry } from '../apiservices/ApiService';
const sleepQualityLabels = [
  { label: "Terrible", icon: <MoodBadIcon fontSize="large" />, value: 0, color: "#f44336" }, // Red
  { label: "Bad", icon: <SentimentDissatisfiedIcon fontSize="large" />, value: 1, color: "#ff9800" }, // Orange
  { label: "Ok", icon: <SentimentSatisfiedIcon fontSize="large" />, value: 2, color: "#ffc107" }, // Yellow
  { label: "Good", icon: <SentimentVerySatisfiedIcon fontSize="large" />, value: 3, color: "#4caf50" }, // Green
  { label: "Great", icon: <MoodIcon fontSize="large" />, value: 4, color: "#3f51b5" }, // Blue
];

// Individual Rating Component
const SleepQualityRating = ({ label, icon, color, selected, onSelect }) => (
  <Box
    sx={{
      textAlign: "center",
      cursor: "pointer",
      padding: "8px",
      border: selected ? `2px solid ${color}` : "2px solid transparent",
      borderRadius: "8px",
      transition: "0.3s",
      backgroundColor: selected ? `${color}1A` : "transparent", // Adds a light tint of the selected color
      "&:hover": {
        backgroundColor: `${color}33`, // Slightly darker hover effect
      },
    }}
    onClick={onSelect}
  >
    <IconButton sx={{ color }}>{icon}</IconButton>
    <Typography variant="caption" sx={{ color: selected ? color : "#666" }}>
      {label}
    </Typography>
  </Box>
);

const Fsn25LogSleep = ({ onTap }) => {


  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [currentWeek, setCurrentWeek] = useState(0);
  const [sleptTime, setSleptTime] = useState(new Date());
  const [wakeUpTime, setWakeUpTime] = useState(new Date());
  const [sleptTime1, setSleptTime1] = useState(new Date());
  const [wakeUpTime1, setWakeUpTime1] = useState(new Date());
  const [sleepQuality, setSleepQuality] = useState(4); // Default to "Great"
  const [loggedEntries, setLoggedEntries] = useState([]);
  const [selectedEntry, setSelectedEntry] = useState(null);

  useEffect(() => {
  
    // Load entries for selected date
    const fetchData = async () => {
     
      // Load entries for selected date
      try {
        const response = await fetchSleepData({
          date: selectedDate,
          dataInDepth: "1",
        });

        const data = response;
       console.log("fetchSleepData",response)
       if (data.length > 0) {
        setLoggedEntries(data);
      }
  
      } catch (error) {
        console.error("Error fetching water data:", error);
      }

      ;
    };

    fetchData();
    formatTimeFromPicker(selectedDate,1)
    formatTimeFromPicker(selectedDate,2)
  }, [selectedDate]);

  const formatTimestamp = (isoString) => {
    const date = new Date(isoString);
    const options = { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    return date.toLocaleString('en-US', options).replace(',', '');
  };


  const handleSubmit = async () => {
   
    console.log("handleSubmit");
    const getCurrentTimeInSeconds = () => {
      const now = new Date();
      return Math.floor(now.getTime() / 1000); // Convert milliseconds to seconds
    };
    const getCurrentTime = () => {
      const now = new Date();
  
      // Format date and time
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Get month (0-based index)
      const day = String(now.getDate()).padStart(2, '0'); // Get day
      const hours = String(now.getHours()).padStart(2, '0'); // Get hours
      const minutes = String(now.getMinutes()).padStart(2, '0'); // Get minutes
      const seconds = String(now.getSeconds()).padStart(2, '0'); // Get seconds
  
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const handleLog = async (e) => {
    
      try {
  
        let payload = JSON.stringify(
       [ {
        "awakeTime" : wakeUpTime,
        "createdTime" :getCurrentTime(),
        "date" : `${selectedDate}`,
        "duration" : "",
        "localSleepId" : getCurrentTimeInSeconds(),
        "logType" : "",
        "minutesAsleep" : 0,
        "rating" : sleepQuality+1,
        "serverSleepId" : 0,
        "sleptTime" : sleptTime,
        "source" : "",
        "status" : "new",
        "timeInBed" : 0,
    }]
   
        )
        const response = await saveSleepLogData({ data: payload });
  
        console.log("weitght/add_wewight API response:", response);
        console.log(payload.createdTime)
        const response1 = await fetchSleepData({
          date: selectedDate,
          dataInDepth: "1",
        });
       
    
        setLoggedEntries(response1);
      } catch (error) {
        console.error('Error updating profile:', error);
      }
    }
   // Data :[{"weight":weight,"source":"goqii","moisture":"0","weightUnit":"KG","serverWeightId":"-1","status":"new","visceralFat":"0","waist":waist,"bodyFat":"0","resistance":"0","createdTime":getCurrentTime(),"date":`${selectedDate}`,"bmr":"0","bmi":"0","protein":"0","skeletalMuscle":"0","localWeightId":`${getCurrentTimeInSeconds()}`,"bone":"0","targetWeight":"0","boneMuscle":"0","hip":"0"}]
   handleLog()
  };
  const handleDeleteEntry = (id) => {
    setLoggedEntries(loggedEntries.filter(entry => entry.serverWeightId !== id));
    setSelectedEntry(null);

    const fetchData = async () => {
      const payload = JSON.stringify([
        {
          serverSleepId: id,
          status: "old",
          source: "GOQii",
          date: `${selectedDate}`,
        },
      ]);

      const deletedResponse = await deleteUserSleepLogEntry({ data: payload });

      const response1 = await fetchSleepData({
        date: selectedDate,
        dataInDepth: "1",
      });
     
  
      setLoggedEntries(response1);
    }
    fetchData()
  };

  const formatTimeFromPicker = (newTime,pickerNo) => {
  try {
    let parsedDate;
    // Check if newTime is a valid ISO 8601 string
    if (typeof newTime === "string") {
      parsedDate = parseISO(newTime); // Use parseISO for ISO 8601 strings
    } else if (newTime instanceof Date) {
      parsedDate = newTime; // Directly use Date objects
    } else {
      parsedDate = new Date(newTime); // Handle other formats
    }
    // Ensure the parsed date is valid
    if (isNaN(parsedDate)) {
      throw new Error("Invalid date value");
    }
    // Extract the time component in "HH:mm:ss" format
    const timeComponent = format(parsedDate, "HH:mm:ss");
    const combinedDateTime = `${selectedDate} ${timeComponent}`;
    // Output: "2025-01-21 16:00:00"
if (pickerNo===1){
    setSleptTime(combinedDateTime);
    setSleptTime1(parsedDate);
}else{
  setWakeUpTime(combinedDateTime)
  setWakeUpTime1(parsedDate)
}
    
  } catch (error) {
    console.error("Error handling time change:", error.message);
  }
}

function get12HrTime(time){
  const parsedDate = parse(time, "yyyy-MM-dd HH:mm:ss", new Date());

// Format the time in 12-hour format with AM/PM
const timeComponent = format(parsedDate, "hh:mm a");

return timeComponent
}


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ padding: "16px" }}>
        <PWAHeader title={onTap?.FAI?.title || "Log Sleep"} />
        <DatePickerRow
          selectedDate={selectedDate}
          onDateSelect={setSelectedDate}
          currentWeek={currentWeek}
          setCurrentWeek={setCurrentWeek}
          restrictPastDates={false}  // Restrict past dates for appointment booking
          restrictFutureDates={true} // Allow future dates
        />

        {/* Log Sleep and Wake Up Times */}
        <Box sx={{ margin: "16px 0" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
            <Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
              <BedtimeIcon sx={{ marginRight: "8px", color: "#607d8b" }} /> Slept
            </Typography>
            <TimePicker
              value={sleptTime1}
              onChange={(newTime) => {
               formatTimeFromPicker(newTime,1)
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
              <WbSunnyIcon sx={{ marginRight: "8px", color: "#ffb300" }} /> Wake Up
            </Typography>
            <TimePicker
              value={wakeUpTime1}
              onChange={(newTime) => {
                formatTimeFromPicker(newTime,2)
               }}
 
              renderInput={(params) => <TextField {...params} />}
            />
          </Box>
        </Box>

        {/* Sleep Quality Section */}
        <Typography variant="subtitle1" sx={{ marginTop: "16px", marginBottom: "8px" }}>
          Rate your sleep quality
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {sleepQualityLabels.map(({ label, icon, value, color }) => (
            <SleepQualityRating
              key={value}
              label={label}
              icon={icon}
              color={color}
              selected={sleepQuality === value}
              onSelect={() => setSleepQuality(value)}
            />
          ))}
        </Box>

        {/* Log Button */}
        <PrimaryButton onClick={handleSubmit} label="Log" />
      </Box>
      < div className="logged-entries-section">
        <div className="section-title">Logged Sleep</div>
        <div className="entries-list">
          {loggedEntries
            .filter(entry => entry.date === selectedDate)
            .map((entry) => (
              <div
                key={entry.serverSleepId}
                className="entry-item"
                onTouchStart={() => {
                  const timer = setTimeout(() => {
                    setSelectedEntry(entry.serverSleepId);
                  }, 2);
                  return () => clearTimeout(timer);
                }}
              >
                <div className="entry-content">
                  <Moon className="water-drop-icon" />
                  <div className="entry-details">
                    <div className="entry-title">Slept</div>
                    <div className="entry-amount">{get12HrTime(entry.sleepTime)} </div>
                  </div>
                </div>
                <div className="entry-content">
                  {/* <FitnessCenterIcon className="water-drop-icon" /> */}
                  <div className="entry-details">
                    <div className="entry-title">WakeUp</div>
                    <div className="entry-amount">{get12HrTime(entry.awakeTime)} </div>
                  </div>
                </div>
                <div className="timestamp-container">
              
                  <div className="timestamp-label">Logged at</div>
                  <div className="timestamp-value">
                    {formatTimestamp(entry.createdTime)}
                  </div>
                </div>
                {selectedEntry === entry.serverSleepId && (
                  <button
                   onClick={() => handleDeleteEntry(entry.serverSleepId)}
                    className="delete-button"
                  >
                    <Delete />
                  </button>
                )}
              </div>
            ))}
        </div>
        </div>
    </LocalizationProvider>

  );
};

export default Fsn25LogSleep;